const IGNORABLE_CLIENT_RUNTIME_ERROR = [
  'Wasm SIMD unsupported',
  'v128 not enabled',
  'WebAssembly is not defined',
  "Can't find variable: WebAssembly",
  'Cannot allocate Wasm memory',
  'Aborted(InternalError: out of memory)',
  'Aborted(out of memory)',
  'Aborted(RangeError: Out of memory)',
  'Array buffer allocation failed',
  'uncaught exception: out of memory',
  'Promise.try is not a function',
];

export const isIgnorableClientRuntimeError = (error: unknown): boolean => {
  const message = typeof error === 'string' ? error : error instanceof Error ? error.message : '';
  if (!message) return false;
  return IGNORABLE_CLIENT_RUNTIME_ERROR.some(part => message.includes(part));
};
